module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="' +
((__t = ( data.verticalClassName )) == null ? '' : __t) +
'">\n    <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="true">\n        ';
 if (data.label) { ;
__p += '\n        <span class="label">' +
((__t = ( data.label )) == null ? '' : __t) +
'</span>\n        ';
 } ;
__p += '\n        <span class="value">' +
((__t = ( data.placeholder )) == null ? '' : __t) +
'</span>\n        <i class="fas fa-chevron-down chevron" aria-hidden="true"></i>\n    </button>\n    ';
 if (data.hasClearButton) { ;
__p += '\n    <div class="clear-dropdown"><i class="fas fa-times-circle"></i></div>\n    ';
 } ;
__p += '\n    <div class="' +
((__t = ( data.horizontalClassName )) == null ? '' : __t) +
'" role="menu" aria-labelledby="dropdownMenu1">\n        ';
 if (data.filter) { ;
__p += '\n        <div class="dropdown-menu-filter">\n            <i class="fal fa-search"></i>\n            <input type="text" placeholder="Search" autocomplete="off" />\n            <i class="fas fa-times-circle clear-value" data-toggle="tooltip" data-placement="top" title="' +
((__t = ( strings.clear )) == null ? '' : __t) +
'" aria-label="' +
((__t = ( strings.clear )) == null ? '' : __t) +
'"></i>\n        </div>\n        ';
 } ;
__p += '\n        <ul class="dropdown-menu-list"></ul>\n    </div>\n</div>\n';
return __p
}